export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose all"])}
}